if (!customElements.get("product-info")) {
  customElements.define(
    "product-info",
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector(".quantity__input");
        this.currentVariant = this.querySelector(".product-variant-id");
        this.submitButton = this.querySelector('[type="submit"]');
        console.log(this.querySelectorAll(".bundle-product-selector select"));
        this.querySelectorAll(".bundle-product-selector select").forEach(
          (select) => {
            select.addEventListener("change", this.priceChange.bind(this));
          },
        );
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector(".product-form__quantity");
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(
            PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this),
          );
        }
        this.variantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          (event) => {
            const sectionId = this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section;
            if (event.data.sectionId !== sectionId) return;
            this.updateQuantityRules(event.data.sectionId, event.data.html);
            this.setQuantityBoundries();
          },
        );
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity
            ? parseInt(this.input.dataset.cartQuantity)
            : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector(
          ".quantity__rules-cart .loading__spinner",
        ).classList.remove("hidden");
        fetch(
          `${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`,
        )
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html",
            );
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector(
              ".quantity__rules-cart .loading__spinner",
            ).classList.add("hidden");
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(
          `Quantity-Form-${sectionId}`,
        );
        const selectors = [
          ".quantity__input",
          ".quantity__rules",
          ".quantity__label",
        ];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === ".quantity__input") {
            const attributes = [
              "data-cart-quantity",
              "data-min",
              "data-max",
              "step",
            ];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null)
                current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      priceChange() {
        const totalCosts = Array.from(this.querySelectorAll("select"))
          .map((select) => select.selectedOptions[0].dataset.priceSet)
          .filter((item) => item)
          .reduce((acc, item) => acc + parseInt(item), 0);

        const priceElement = document.querySelector("product-info .price");

        if (priceElement.classList.contains("price--on-sale")) {
          const normalPrice = parseInt(
            document.querySelector("product-info .price").dataset.price,
          );

          const newNormalPrice = this.formatMoney(
            normalPrice + totalCosts,
            this.getAttribute("data-money-format"),
          );
          priceElement.querySelector(
            "product-info .price__sale .price-item--sale span:first-child",
          ).innerHTML = newNormalPrice;
          const comparePrice = parseInt(
            document.querySelector("product-info .price").dataset.comparePrice,
          );
          const newComparePrice = this.formatMoney(
            comparePrice + totalCosts,
            this.getAttribute("data-money-format"),
          );
          priceElement.querySelector(
            "product-info .price__sale s.price-item--regular",
          ).innerHTML = newComparePrice;
        } else {
          const normalPrice = parseInt(
            document.querySelector("product-info .price").dataset.price,
          );
          console.log(normalPrice, totalCosts, normalPrice + totalCosts);

          const newNormalPrice = this.formatMoney(
            normalPrice + totalCosts,
            this.getAttribute("data-money-format"),
          );
          priceElement.querySelector(
            "product-info .price__regular .price-item--regular",
          ).innerHTML = newNormalPrice;
        }
      }

      formatMoney(cents, format) {
        if (typeof cents == "string") {
          cents = cents.replace(".", "");
        }
        var value = "";
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        var formatString = format || this.money_format;

        function defaultOption(opt, def) {
          return typeof opt == "undefined" ? def : opt;
        }

        function formatWithDelimiters(number, precision, thousands, decimal) {
          precision = defaultOption(precision, 2);
          thousands = defaultOption(thousands, ",");
          decimal = defaultOption(decimal, ".");

          if (isNaN(number) || number == null) {
            return 0;
          }

          number = (number / 100.0).toFixed(precision);

          var parts = number.split("."),
            dollars = parts[0].replace(
              /(\d)(?=(\d\d\d)+(?!\d))/g,
              "$1" + thousands,
            ),
            cents = parts[1] ? decimal + parts[1] : "";

          return dollars + cents;
        }

        var match = formatString.match(placeholderRegex);

        if (match) {
          switch (match[1]) {
            case "amount":
              value = formatWithDelimiters(cents, 2);
              break;
            case "amount_no_decimals":
              value = formatWithDelimiters(cents, 0);
              break;
            case "amount_with_comma_separator":
              value = formatWithDelimiters(cents, 0, ".", ",");
              break;
            case "amount_no_decimals_with_comma_separator":
              value = formatWithDelimiters(cents, 0, ".", ",");
              break;
          }
        }

        return formatString.replace(placeholderRegex, value);
      }
    },
  );
}
